// extracted by mini-css-extract-plugin
export default {"updateEmailSection":"update-email_updateEmailSection__Lv5Iw","btnDefault":"update-email_btnDefault__bK1zi","emailText":"update-email_emailText__Nu980"};